import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';

const Component = ({ time, className, format, fallback }) => {
    const formatStirng = format || I18n.t('datetime_format.long');
    return (
        <time className={ className }>{ time && moment(time).isValid() ? moment(time).format(formatStirng) : ( fallback || '--') }</time>
    );
};

Component.propTypes = {
    time: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.instanceOf(moment)
    ]),
    className: PropTypes.string,
    format: PropTypes.string,
    fallback: PropTypes.string,
};

Component.defaultProps = {
    time: '',
    className: '',
    format: undefined,
    fallback: undefined,
};

export default Component;
